import { AnyAction } from 'redux';
import { AxiosPromise, AxiosResponse } from 'axios';
import { ServerResponse } from 'data/types';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'data/root.reducers';

export const API_PATH_AFWHITELIST = '/afwhitelist';

export const SET_AFWHITELIST_LOADING = 'SET_AFWHITELIST_LOADING';
export const GO_TO_AFWHITELIST_CREATE = 'GO_TO_AFWHITELIST_CREATE';
export const GO_TO_AFWHITELIST_EDIT = 'GO_TO_AFWHITELIST_EDIT';
export const GO_TO_AFWHITELIST_VIEW = 'GO_TO_AFWHITELIST_VIEW';
export const GO_TO_AFWHITELIST_COPY = 'GO_TO_AFWHITELIST_COPY';
export const GO_TO_AFWHITELIST_LIST = 'GO_TO_AFWHITELIST_LIST';
export const GET_AFWHITELIST_LIST = 'GET_AFWHITELIST_LIST';
export const GET_AFWHITELIST_LIST_PENDING = 'GET_AFWHITELIST_LIST_PENDING';
export const GET_AFWHITELIST_LIST_FULFILLED = 'GET_AFWHITELIST_LIST_FULFILLED';
export const GET_AFWHITELIST = 'GET_AFWHITELIST';
export const GET_AFWHITELIST_PENDING = 'GET_AFWHITELIST_PENDING';
export const GET_AFWHITELIST_FULFILLED = 'GET_AFWHITELIST_FULFILLED';
export const CREATE_AFWHITELIST = 'CREATE_AFWHITELIST';
export const CREATE_AFWHITELIST_PENDING = 'CREATE_AFWHITELIST_PENDING';
export const CREATE_AFWHITELIST_FULFILLED = 'CREATE_AFWHITELIST_FULFILLED';
export const CREATE_AFWHITELIST_REJECTED = 'CREATE_AFWHITELIST_REJECTED';
export const UPDATE_AFWHITELIST = 'UPDATE_AFWHITELIST';
export const UPDATE_AFWHITELIST_FULFILLED = 'UPDATE_AFWHITELIST_FULFILLED';
export const UPDATE_AFWHITELIST_REJECTED = 'UPDATE_AFWHITELIST_REJECTED';
export const DELETE_AFWHITELIST = 'DELETE_AFWHITELIST';
export const DELETE_AFWHITELIST_FULFILLED = 'DELETE_AFWHITELIST_FULFILLED';
export const DELETE_AFWHITELIST_REJECTED = 'DELETE_AFWHITELIST_REJECTED';
export const SELECT_AFWHITELIST = 'SELECT_AFWHITELIST';

export enum AfwhitelistPrivileges {
  View = 'dc_access',
  Edit = 'dc_access',
  Delete = 'dc_access',
}

export enum AfwhitelistMenuActionsType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view'
}

export interface AfWhitelist {
  id: string,
  AFID: string,
  AFPROTOCOL: string
  AFTYPE: string
  GRAYITEM: string
  IPADDR: string
}

export interface AdaptedAfWhitelist {
  id: string,
  AFID: string,
  AFPROTOCOL: string
  AFTYPE: string
  GRAYITEM: boolean
  IPADDR: string
}

export interface AfWhitelistState {
  entities: AfWhitelist[]
  selected: AfWhitelist[],
  single: AfWhitelist | null
  createdId: string | null
  ui: AfWhitelistUIState
}

export interface AfWhitelistUIState {
  isCreatePopupOpen: boolean
  isLoading: boolean
}

export interface GoToAfWhitelistListAction extends AnyAction {
  type: typeof GO_TO_AFWHITELIST_LIST;
}

export interface SetAfWhitelistLoadingAction extends AnyAction {
  type: typeof SET_AFWHITELIST_LOADING;
  payload: { isLoading: boolean };
}

export interface GetAfWhitelistListAction extends AnyAction {
  type: typeof GET_AFWHITELIST_LIST;
  payload: AxiosPromise<ServerResponse<AfWhitelist>>;
}

export interface GetAfWhitelistListPendingAction extends AnyAction {
  type: typeof GET_AFWHITELIST_LIST_PENDING;
  payload: null;
}

export interface GetAfWhitelistListFulfilledAction extends AnyAction {
  type: typeof GET_AFWHITELIST_LIST_FULFILLED;
  payload: AxiosResponse<ServerResponse<AfWhitelist>>;
}

export interface GetAfWhitelistAction extends AnyAction {
  type: typeof GET_AFWHITELIST;
  payload: AxiosPromise<ServerResponse<AfWhitelist>>;
}

export interface GetAfWhitelistPendingAction extends AnyAction {
  type: typeof GET_AFWHITELIST_PENDING;
  payload: null;
}

export interface GetAfWhitelistFulfilledAction extends AnyAction {
  type: typeof GET_AFWHITELIST_FULFILLED;
  payload: AxiosResponse<ServerResponse<AfWhitelist>>;
}

export interface CreateAfWhitelistThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
export interface CreateAfWhitelistAction extends AnyAction {
  type: typeof CREATE_AFWHITELIST;
  payload: AxiosPromise<ServerResponse<AfWhitelist>>;
}

export interface CreateAfWhitelistPendingAction extends AnyAction {
  type: typeof CREATE_AFWHITELIST_PENDING;
  payload: null;
}

export interface CreateAfWhitelistFulfilledAction extends AnyAction {
  type: typeof CREATE_AFWHITELIST_FULFILLED;
  payload: AxiosResponse<ServerResponse<AfWhitelist>>;
}

export interface CreateAfWhitelistRejectedAction extends AnyAction {
  type: typeof CREATE_AFWHITELIST_REJECTED;
  payload: AxiosResponse<ServerResponse<AfWhitelist>>;
}

export interface UpdateAfWhitelistThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
export interface UpdateAfWhitelistAction extends AnyAction {
  type: typeof UPDATE_AFWHITELIST;
  payload: AxiosPromise<ServerResponse<AfWhitelist>>;
}

export interface UpdateAfWhitelistFulfilledAction extends AnyAction {
  type: typeof UPDATE_AFWHITELIST_FULFILLED;
  payload: AxiosResponse<ServerResponse<AfWhitelist>>;
}

export interface UpdateAfWhitelistRejectedAction extends AnyAction {
  type: typeof UPDATE_AFWHITELIST_REJECTED;
  payload: AxiosResponse<ServerResponse<AfWhitelist>>;
}

export interface DeleteAfWhitelistThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
export interface DeleteAfWhitelistAction extends AnyAction {
  type: typeof DELETE_AFWHITELIST;
  payload: AxiosPromise<ServerResponse<AfWhitelist>>;
}

export interface DeleteAfWhitelistFulfilledAction extends AnyAction {
  type: typeof DELETE_AFWHITELIST_FULFILLED;
  payload: AxiosResponse<ServerResponse<AfWhitelist>>;
}

export interface DeleteAfWhitelistRejectedAction extends AnyAction {
  type: typeof DELETE_AFWHITELIST_REJECTED;
  payload: AxiosResponse<ServerResponse<AfWhitelist>>;
}

export interface SelectAfWhitelistAction extends AnyAction {
  type: typeof SELECT_AFWHITELIST;
  payload: AfWhitelist[];
}

export type AfWhitelistActionTypes =
  GoToAfWhitelistListAction |
  SetAfWhitelistLoadingAction |
  GetAfWhitelistListAction |
  GetAfWhitelistListPendingAction |
  GetAfWhitelistListFulfilledAction |
  GetAfWhitelistAction |
  GetAfWhitelistPendingAction |
  GetAfWhitelistFulfilledAction |
  CreateAfWhitelistAction |
  CreateAfWhitelistPendingAction |
  CreateAfWhitelistFulfilledAction |
  CreateAfWhitelistRejectedAction |
  UpdateAfWhitelistAction |
  UpdateAfWhitelistFulfilledAction |
  UpdateAfWhitelistRejectedAction |
  DeleteAfWhitelistAction |
  DeleteAfWhitelistFulfilledAction |
  DeleteAfWhitelistRejectedAction |
  SelectAfWhitelistAction;
